import Plant from "../Plant";

export const plantDefaultValues: Plant = {
  Id: 0,
  Gsdb: "",
  Name: "",
  TwoDigitCode: "",
  City: "",
  Street: "",
  ZipCode: "",
  PlantDetails: "",
  PartDestination: 0,
  EdcId: 0,
  CountryId: 0,
  CountryIsoCode: "",
  ZipArea: "",
  Region: "",
  Latitude: undefined,
  Longitude: undefined,
  MapAndGuideLatitude: null,
  MapAndGuideLongitude: null,
};
